import { FC, useContext, useEffect, MouseEvent, useState } from "react";
import { Link, useNavigate, NavLink, useLocation } from "react-router-dom";

import DropdownStatusColorMeaning from "../dropdownStatusColorMeaning";

import { AuthContext } from "src/context/authContext";
import { LoaderContext } from "src/context/loaderContext";
import { ToastContext } from "src/context/toastContext";
import useFetch from "src/hooks/useFetch";

import { SiteLogo } from "src/assets";
import { AuthenticatedHCPHeader, AuthenticatedManufactureHeader } from "src/constants/headerLinks";
import { HeaderElementType, ToastTypes } from "src/types";
import { APIEndpoints } from "src/types/apiTypes";
import { LogoutAPISuccessResponseType, ResetDemoCasesAPISuccessResponseType } from "./types";
import { redirectPath } from "src/helpers/headers";
import MarkCaseCEP from "../modals/markCaseCEP";
import DropdownPossibleNextStep from "../dropdownPossibleNextSteps";
import { isNotKAMUser } from "src/helpers";

// import DropdownPossibleNextStep from "../dropdownPossibleNextSteps";
// import { UserObjectType } from "../authSubHeader/types";



const AuthHeader: FC = (): JSX.Element => {
  const navigate = useNavigate();
  const { userData, destroySession, isManufacturer, isUserAuthorized, eob_warehouse, upload_eob, cep_popup } = useContext(AuthContext);
  const { setLoader, hideLoader } = useContext(LoaderContext);
  const { showToast } = useContext(ToastContext);
  const location = useLocation()
  const [showCEP, setShowCEP] = useState<boolean>();


  const { mutate, error, data, removeErrorAndData } = useFetch<LogoutAPISuccessResponseType>(APIEndpoints.USER_LOGOUT);
  const { mutate: resetDemoCasesApi, data: resetDemoCasesApiResponse, error: resetDemoCasesApiResponseError } = useFetch<ResetDemoCasesAPISuccessResponseType>(APIEndpoints.DEMO_RESET_CASES);
  const ResetDemoCases = localStorage.getItem("resetDemoCases");

  const resetDemoCases = () => {
    resetDemoCasesApi();
  }

  useEffect(() => {
    if (resetDemoCasesApiResponse?.status === 'success' || resetDemoCasesApiResponseError) {
      hideLoader();
      if (resetDemoCasesApiResponse?.status === 'success') {
        showToast([resetDemoCasesApiResponse.message], ToastTypes.SUCCESS);
        if (window.location.pathname === "/cases") {
          navigate(0)
        } else {
          navigate('/cases');
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resetDemoCasesApiResponse, error]);

  useEffect(() => {
    if (data?.status === 200 || error) {
      hideLoader();
      destroySession();
      if (data?.status === 200) {
        showToast([data.message], ToastTypes.SUCCESS);
        navigate('/users/sign_in');
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, error]);

  const logoutUser = (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    if ((error && error.length > 0) || data) removeErrorAndData();

    setLoader();
    mutate();
  };

  const onCEPClick = (title: string) => {
    if (
      title === "CEP" && cep_popup && window.location.pathname !== "/todos_statistics" &&
      window.location.pathname !== "/patient_statistics"
    ) {
      setShowCEP(true)
    }
  }
  const getNavLinkPath = (headerLink: any, userData: any) => {
    if (!userData) return "";

    const { title, redirectLink } = headerLink;
    const { id, ref_type } = userData;


    //console.log("title",title,"redirectLink",redirectLink,"id",id,"ref_type",ref_type)
    // CASE 1: "Cases" tab — redirect using helper
    if (title === "Cases") {
      return redirectPath(userData);
    }

    // CASE 2: Statistics tabs
    if (redirectLink === "/todos_statistics" || redirectLink === "/patient_statistics") {
      return `${redirectLink}?id=${id}&role=${ref_type}`;
    }

    // CASE 3: All others — only append query if not manufacturer
    const query =
      ref_type !== "Manufacturer" ? `?id=${id}&role=${ref_type}` : "";

    return `${redirectLink}${query}`;
  };



  const authenticatedHCPHeader = () => {
    return (
      AuthenticatedHCPHeader.map((headerLink, index) => (
        <li
          className={`nav-item ${headerLink.actionType === HeaderElementType.DRPODOWN ? 'dropdown' : ''}`}
          key={index}
        >
          {headerLink.actionType === HeaderElementType.ROUTE ? (
            <NavLink
              className={({ isActive }) => {
                return ["nav-link", isActive ? "custom-active-link" : ""].join(" ")
              }}
              reloadDocument={
                headerLink.redirectLink === "/cases/new" &&
                (location.pathname.includes("clone") || location.pathname.includes("new"))
              }
              aria-current="page"
              to={headerLink.redirectLink}
              end
            >
              {headerLink.title}
            </NavLink>
          ) : null}
          {headerLink.actionType === HeaderElementType.BUTTON ? (
            <button style={{ background: 'background-color-5' }} className="btn btn-primary rounded-pill"
              onClick={() => { navigate(headerLink.redirectLink) }}>
              {headerLink.title}
            </button>
          ) : null}
          {headerLink.actionType === HeaderElementType.LINK ? (
            <a className="nav-link" href={headerLink.redirectLink} target="_blank" rel="noreferrer">
              {headerLink.title}
            </a>
          ) : null}
          {headerLink.actionType === HeaderElementType.DRPODOWN ? (
            <>
              <a className="nav-link dropdown-toggle" href="." data-bs-toggle="dropdown" aria-expanded="false">
                Resources
              </a>
              <ul className="resources-dropdown dropdown-menu dropdown-center" style={{ top: '53px' }}>
                {headerLink.dropdown && headerLink.dropdown.map((header, index) => (
                  <li key={index}>
                    <a className="dropdown-item" href={header.redirectLink} target="_blank" rel="noreferrer">
                      {header.title}
                    </a>
                  </li>
                ))}
              </ul>
            </>
          ) : null}
        </li>
      ))
    )
  }

  const authenticatedManufactureHeader = () => {
    return (
      AuthenticatedManufactureHeader.map((headerLink, index) => (
        <li
          className={`nav-item ${headerLink.actionType === HeaderElementType.DRPODOWN ? 'dropdown' : ''}`}
          key={index}
        >
          {headerLink.actionType === HeaderElementType.ROUTE ? (userData && isNotKAMUser(userData.ref_type) ?
            (<NavLink
              className={({ isActive }) => {
                return ["nav-link", isActive ? "custom-active-link" : ""].join(" ")
              }}
              aria-current="page"
              // to={
              //   headerLink.title === "Cases" ? (userData ? redirectPath(userData) : "") : (headerLink.title === "todos_statistics"  ||  headerLink.title === "patient_statistics" ) ? `${headerLink.redirectLink}?id=${userData?.id}&role=${userData?.ref_type}`:`${headerLink.redirectLink}${userData?.ref_type !== "Manufacturer" ? `?id=${userData?.id}&role=${userData?.ref_type}` : "" } `
              // }
              to={getNavLinkPath(headerLink, userData)}
              end
            >
              {headerLink.title}
            </NavLink>) :
            (headerLink.title !== "Action Dashboard" && headerLink.title !== "Cases" && <NavLink
              className={({ isActive }) => {
                return ["nav-link", isActive ? "custom-active-link" : ""].join(" ")
              }}
              aria-current="page"
              // to={
              //   headerLink.title === "Cases" ? (userData ? redirectPath(userData) : "") : (headerLink.title === "todos_statistics"  ||  headerLink.title === "patient_statistics" ) ? `${headerLink.redirectLink}?id=${userData?.id}&role=${userData?.ref_type}`:`${headerLink.redirectLink}${userData?.ref_type !== "Manufacturer" ? `?id=${userData?.id}&role=${userData?.ref_type}` : "" } `
              // }
              to={getNavLinkPath(headerLink, userData)}
              end
            >
              {headerLink.title}
            </NavLink>)

          ) : null}
          {headerLink.actionType === HeaderElementType.BUTTON ? (
            <button
              className="btn btn-primary rounded-pill"
              onClick={() => {
                navigate(headerLink.redirectLink)
              }}
            >
              {headerLink.title}
            </button>
          ) : null}
          {headerLink.actionType === HeaderElementType.LINK ? (
            <a className="nav-link" href={headerLink.redirectLink} target="_blank" rel="noreferrer"

            >
              {headerLink.title}
            </a>
          ) : null}
          {headerLink.actionType === HeaderElementType.DRPODOWN ? (
            <>
              <a
                className="nav-link dropdown-toggle"
                href="." data-bs-toggle="dropdown" aria-expanded="false"
              >
                {headerLink.title}
              </a>
              <ul className="resources-dropdown dropdown-menu dropdown-center">
                {headerLink.dropdown && headerLink.dropdown.map((header, index) => {
                  const headerEle = (
                    <li key={index}>
                      <a
                        className="dropdown-item"
                        {...(header.title !== "CEP" ? {
                          target: "_blank",
                          rel: "noreferrer",
                          href: header.redirectLink
                        } : {
                        })}
                        onClick={() => { onCEPClick((header.title).toString()) }}
                      >
                        {header.title}

                      </a>
                    </li>
                  )

                  if (header.title === "EOB Warehouse" && eob_warehouse) return headerEle
                  if (header.title === "UploadEOB" && upload_eob) return headerEle
                  if (header.title !== "EOB Warehouse" && header.title !== "UploadEOB") return headerEle
                  else return null
                })}
              </ul>
            </>
          ) : null}
        </li>
      ))
    )
  }
  //  const authenticatedAreaManagerHeader = () => {
  //   return (
  //     AuthenticatedAreaManagerHeader.map((headerLink, index) => (
  //       <li
  //         className={`nav-item ${headerLink.actionType === HeaderElementType.DRPODOWN ? 'dropdown' : ''}`}
  //         key={index}
  //       >
  //         {headerLink.actionType === HeaderElementType.ROUTE ? (
  //           <NavLink
  //             className={({ isActive }) => {
  //               return ["nav-link", isActive ? "custom-active-link" : ""].join(" ")
  //             }}
  //             aria-current="page"
  //             to={
  //               headerLink.title === "Cases" ?
  //                 (userData ? redirectPath(userData) : "") :
  //                 `${headerLink.redirectLink}${userData?.ref_type !== "Manufacturer" ? `?id=${userData?.id}&role=${userData?.ref_type}` : ""}`
  //             }
  //             end
  //           >
  //             {headerLink.title}
  //           </NavLink>
  //         ) : null}
  //         {headerLink.actionType === HeaderElementType.BUTTON ? (
  //           <button
  //             className="btn btn-primary rounded-pill"
  //             onClick={() => {
  //               navigate(headerLink.redirectLink)
  //             }}
  //           >
  //             {headerLink.title}
  //           </button>
  //         ) : null}
  //         {headerLink.actionType === HeaderElementType.LINK ? (
  //           <a className="nav-link" href={headerLink.redirectLink} target="_blank" rel="noreferrer"

  //           >
  //             {headerLink.title}
  //           </a>
  //         ) : null}
  //         {headerLink.actionType === HeaderElementType.DRPODOWN ? (
  //           <>
  //             <a
  //               className="nav-link dropdown-toggle"
  //               href="." data-bs-toggle="dropdown" aria-expanded="false"
  //             >
  //               {headerLink.title}
  //             </a>
  //             <ul className="resources-dropdown dropdown-menu dropdown-center">
  //               {headerLink.dropdown && headerLink.dropdown.map((header, index) => (
  //                 <li key={index}>
  //                   <a
  //                     className="dropdown-item" target="_blank"
  //                     rel="noreferrer"
  //                     href={header.title === "CEP" ? undefined : header.redirectLink}
  //                   >
  //                     {header.title}
  //                   </a>
  //                 </li>
  //               ))}

  //             </ul>
  //           </>
  //         ) : null}
  //       </li>
  //     ))
  //   )
  // }
  // const getLandingPage = localStorage.getItem("landingPage")
  // console.log("getLandingPage....",getLandingPage)

  const getLandingPage = localStorage.getItem("landingPage");

  const landingPath =
    getLandingPage && getLandingPage.trim() !== ""
      ? `/${getLandingPage}`
      : "/cases";

  return (
    <>
      <nav className="navbar navbar-expand-lg px-2 py-0 bg-primary-dark">
        <Link
          className="navbar-brand"
          to={
            isUserAuthorized
              ? userData?.is_password_changed
                ? isManufacturer
                  ? isNotKAMUser(userData.ref_type)
                    ? redirectPath(userData)
                    : `/patient_statistics?id=${userData.id}&role=${userData.ref_type}`
                  : landingPath
                : `/users/${userData?.id}/edit`
              : `/users/sign_in`
          }
        >
          <img className="img-fluid after-login-logo" src={SiteLogo} alt="Site logo" />
        </Link>

        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#authHeader">
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="authHeader">
          <ul className="navbar-nav me-auto first-nav align-items-lg-center text-lg-center">
            {userData && userData.is_password_changed ?
              (isManufacturer === true ?
                authenticatedManufactureHeader()
                :
                authenticatedHCPHeader()
              )
              : <></>
            }
          </ul>

          <ul className="navbar-nav justify-content-end">
            {userData?.is_password_changed ? (
              isManufacturer ? (
                <>
                  <DropdownPossibleNextStep />
                  <DropdownStatusColorMeaning />
                  <li className="nav-item dropdown">
                    <a className="nav-link dropdown-toggle" href="." data-bs-toggle="dropdown"
                      aria-expanded="false" role="button"
                    >
                      {userData?.name}
                    </a>
                    <ul className="dropdown-menu dropdown-menu-end">
                      <li><Link className="dropdown-item text-black" to={`/users/${userData.id}/edit`}>Account
                        Settings</Link>
                      </li>
                      <li>
                        <hr className="dropdown-divider" />
                      </li>
                      <li><a className="dropdown-item text-black" href="."
                        onClick={logoutUser}>Logout</a>
                      </li>
                    </ul>
                  </li>
                </>
              ) : (
                <>
                  <DropdownPossibleNextStep />
                  <DropdownStatusColorMeaning />
                  <li className="nav-item dropdown">
                    <a className="nav-link dropdown-toggle" href="." data-bs-toggle="dropdown"
                      aria-expanded="false"
                      role="button"
                    >
                      {userData?.name}
                    </a>
                    <ul className="dropdown-menu dropdown-menu-end">
                      <li>
                        <Link className="dropdown-item text-black" to={`/users/${userData.id}/edit`}>
                          Account
                          Settings
                        </Link>
                      </li>
                      {(userData.ref_type !== "GlobalDoctor") &&
                        <>
                          <li><Link className="dropdown-item text-black" to="/users/new">Add User</Link>
                          </li>
                          <li><Link className="dropdown-item text-black" to="/global_doctors/new">Add
                            Provider</Link>
                          </li>
                        </>}
                      <li><Link className="dropdown-item text-black" to="/pages/baa">BAA</Link></li>
                      {ResetDemoCases === "true" && (
                        <li><button type="button" className="dropdown-item text-black" onClick={resetDemoCases}>Reset Demo Cases</button></li>
                      )}
                      <li>
                        <hr className="dropdown-divider" />
                      </li>
                      <li><a className="dropdown-item text-black" href="."
                        onClick={logoutUser}>Logout</a>
                      </li>
                    </ul>
                  </li>
                </>
              )
            ) : (
              <li className="nav-item dropdown">
                <a className="nav-link dropdown-toggle"
                  href="." data-bs-toggle="dropdown"
                  aria-expanded="false"
                  role="button"
                >
                  {userData?.name}
                </a>
                <ul className="dropdown-menu dropdown-menu-end">
                  <li><a className="dropdown-item text-black" href="." onClick={logoutUser}>Logout</a></li>
                </ul>
              </li>
            )}
          </ul>
        </div>
      </nav>

      {showCEP ? (
        <MarkCaseCEP onClose={() => setShowCEP(false)} />
      ) : null}
    </>
  );
};

export default AuthHeader;
